<template>
  <span
    v-if="currentArea"
    class="flex"
  >
    <b-row
      class="match-height"
    >
      <b-col
        md="3"
        cols="12"
      >
        <card-welcome
          :area="currentArea"
          :full-name="fullName"
        />
      </b-col>

      <!-- <b-col
        md="9"
        cols="12"
      >
        <card-analytic-sale-line-chart />
      </b-col> -->
    </b-row>
    <b-row>
      <b-col
        md="4"
        cols="12"
      >
        <card-counters
          :refaid="currentArea.aid"
          table="contributors"
          icon="Mail"
          color="#A8AEFF"
        />
      </b-col>
      <b-col
        md="4"
        cols="12"
      >
        <card-counters
          :refaid="currentArea.aid"
          table="sad"
          icon="Users"
          color="#ff9f43"
        />
      </b-col>

      <b-col
        md="4"
        cols="12"
      >
        <card-counters
          :refaid="currentArea.aid"
          table="projects"
          icon="Globe"
          color="#28c76f"
        />
      <!-- color="#7743CE" -->
      <!-- color="#A8AEFF" -->
      </b-col>
    </b-row>
  </span>
</template>

<script>

import { BRow, BCol } from 'bootstrap-vue'
import CardWelcome from '@/views/home/CardWelcome.vue'
import CardCounters from '@/views/home/CardCounters.vue'
// import CardAnalyticSaleLineChart from '@/views/home/CardAnalyticSaleLineChart.vue'

import authService from '@/vue.auth.service'

export default {
  components: {
    BRow,
    BCol,
    CardWelcome,
    CardCounters,
    // CardAnalyticSaleLineChart,
  },
  data() {
    return {
      currentArea: null,
      fullName: null,
    }
  },
  async mounted() {
    await this.reload()
    // eslint-disable-next-line no-underscore-dangle
    if (!this._events.changedArea) {
      this.$root.$on('changedArea', () => {
        this.reload()
      })
    }
  },
  beforeDestroy() {
    this.$root.$off('changedArea')
  },
  methods: {
    async reload() {
      this.currentArea = await authService.currentArea()
      this.fullName = await authService.getFullName()
    },
  },
}
</script>
